import React from "react";
import WildHorse from "assets/images/saddle_logo_icon.png";

// TODO (meeting req): Add horse dropdown when user has multiple horses; only scanned horses (SCAN/LIVE).
// When single horse, keep current behavior (auto-select from card).
const Step1HorseInfo = ({ horseData }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="w-full mb-4 sm:mb-6">
        <h3 className="text-base sm:text-lg lg:text-xl font-bold text-[#2b364b] mb-3 sm:mb-4 text-center font-montserrat">
          Horse Information
        </h3>

        <div className="flex flex-col items-center gap-3 sm:gap-4">
          {/* Horse Photo */}
          <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 rounded-lg overflow-hidden">
            <img
              src={horseData?.photo?.trim() ? horseData.photo : WildHorse}
              alt={horseData?.name || "Horse"}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Horse Name */}
          <h2 className="text-lg sm:text-xl lg:text-2xl font-bold font-montserrat text-[#2b364b]">
            {horseData?.name || "Horse Name"}
          </h2>

          {/* Message */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4 mt-2 sm:mt-4 max-w-md w-full">
            <p className="text-xs sm:text-sm text-blue-800 text-center font-montserrat">
              Your horse&apos;s measurements will be automatically included in the
              custom saddle request.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1HorseInfo;
